import { IComponentOptions, IController } from "angular";
import { IPlugin, IPluginsStoreState, PluginsActions } from "@gtmhub/plugins";
import { INgRedux } from "@gtmhub/state-management";
import { GtmhubController } from "@gtmhub/core";
import { IIndicator, IUIError, UIErrorHandlingService } from "@gtmhub/error-handling";
import { IExtendedRootScopeService } from "@gtmhub/shared/ng-extensions";
import { filterPluginsByType } from "../../redux/plugin-selectors";

const bindStateToScope = (state: IPluginsStoreState): IPluginsRedux => ({
  plugins: filterPluginsByType(state.plugins.items, "ui"),
  reduxItemsFetched: state.plugins.isFetched,
  reduxItemsError: state.plugins.error,
});

interface IPluginsRedux {
  plugins: IPlugin[];
  reduxItemsFetched: boolean;
  reduxItemsError: IUIError;
}
export class PluginListCtrl extends GtmhubController implements IController {
  public plugins: IPlugin[];
  public reduxItemsFetched: boolean;
  public reduxItemsError: IUIError;

  public indicators: {
    loadingPlugins?: IIndicator;
  };

  static $inject = ["$scope", "$ngRedux", "PluginsActions", "UIErrorHandlingService"];

  constructor(
    private $scope: IExtendedRootScopeService,
    private $ngRedux: INgRedux,
    private pluginsActions: PluginsActions,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {
    super();

    this.indicators = {
      loadingPlugins: {
        progress: true,
      },
    };

    this.onDestroy($ngRedux.connect(bindStateToScope)(this));
    this.$ngRedux.dispatch(this.pluginsActions.getPlugins());
  }

  $onInit(): void {
    this.$scope
      .watchUntilAndRejectOnError(
        () => this.reduxItemsFetched,
        () => this.reduxItemsError
      )
      .then(
        () => {
          delete this.indicators.loadingPlugins;
        },
        () => {
          delete this.indicators.loadingPlugins;
          this.uiErrorHandlingService.handleModal(this.reduxItemsError);
        }
      );
  }

  resetIndicator = (indicator: keyof PluginListCtrl["indicators"]): void => {
    delete this.indicators[indicator];
  };
}

export const PluginListComponent: IComponentOptions = {
  controller: PluginListCtrl,
  bindings: {},
  templateUrl: require("./plugin-list.component.jade"),
};
